module.exports = __webpack_public_path__ + "img/stock-03.4e8c8b4.jpg";